var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_month_black_24dp_1_",
    "data-name": "calendar_month_black_24dp (1)",
    transform: "translate(0.189 0.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2188",
    "data-name": "Group 2188"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3411",
    "data-name": "Rectangle 3411",
    width: 21,
    height: 21,
    transform: "translate(-0.189 -0.189)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2189",
    "data-name": "Group 2189",
    transform: "translate(2.638 1.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8379",
    "data-name": "Path 8379",
    d: "M17.07,3.759h-.879V2H14.432V3.759H7.4V2H5.638V3.759H4.759a1.751,1.751,0,0,0-1.75,1.759L3,17.829a1.758,1.758,0,0,0,1.759,1.759H17.07a1.764,1.764,0,0,0,1.759-1.759V5.518A1.764,1.764,0,0,0,17.07,3.759Zm0,14.07H4.759V9.035H17.07ZM8.276,12.553H6.518V10.794H8.276Zm3.518,0H10.035V10.794h1.759Zm3.518,0H13.553V10.794h1.759ZM8.276,16.07H6.518V14.311H8.276Zm3.518,0H10.035V14.311h1.759Zm3.518,0H13.553V14.311h1.759Z",
    transform: "translate(-3 -2)",
    fill: "#f8f9ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/calendar_2.b8fcdfe4fa87566ec17e1ed14e92247b.svg";
export { ForwardRef as ReactComponent };